 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"default~components-appointments-app-module~routes-audit-log-audit-log-module~routes-devices-devices-~113f39d9":"default~components-appointments-app-module~routes-audit-log-audit-log-module~routes-devices-devices-~113f39d9","default~components-appointments-app-module~routes-patients-overview-overview-module~routes-patients-~5fb513a5":"default~components-appointments-app-module~routes-patients-overview-overview-module~routes-patients-~5fb513a5","default~components-appointments-app-module~routes-patients-overview-overview-module~routes-screen-sc~039700e5":"default~components-appointments-app-module~routes-patients-overview-overview-module~routes-screen-sc~039700e5","default~components-appointments-app-module~routes-screen-screen-module":"default~components-appointments-app-module~routes-screen-screen-module","components-appointments-app-module":"components-appointments-app-module","default~routes-audit-log-audit-log-module~routes-devices-devices-module~routes-patients-overview-ove~6580492d":"default~routes-audit-log-audit-log-module~routes-devices-devices-module~routes-patients-overview-ove~6580492d","default~routes-medical-staff-medical-staff-module~routes-patients-overview-overview-module~routes-pa~5c79f3f6":"default~routes-medical-staff-medical-staff-module~routes-patients-overview-overview-module~routes-pa~5c79f3f6","default~routes-audit-log-audit-log-module~routes-patients-overview-overview-module~routes-patients-p~a2272458":"default~routes-audit-log-audit-log-module~routes-patients-overview-overview-module~routes-patients-p~a2272458","default~daily-conclusion-daily-conclusion-module~routes-report-report-module":"default~daily-conclusion-daily-conclusion-module~routes-report-report-module","routes-report-report-module":"routes-report-report-module","default~routes-audit-log-audit-log-module~routes-devices-devices-module~routes-patients-overview-ove~b66bdf83":"default~routes-audit-log-audit-log-module~routes-devices-devices-module~routes-patients-overview-ove~b66bdf83","default~routes-devices-devices-module~routes-google-maps-google-maps-module~routes-patients-overview~a0bb2fc7":"default~routes-devices-devices-module~routes-google-maps-google-maps-module~routes-patients-overview~a0bb2fc7","default~routes-patients-overview-overview-module~routes-patients-patients-module~routes-questionarie~b4eda962":"default~routes-patients-overview-overview-module~routes-patients-patients-module~routes-questionarie~b4eda962","default~routes-patients-overview-overview-module~routes-screen-screen-module":"default~routes-patients-overview-overview-module~routes-screen-screen-module","default~routes-google-maps-google-maps-module~routes-screen-screen-module":"default~routes-google-maps-google-maps-module~routes-screen-screen-module","default~routes-screen-screen-module~users-user-notification-settings-user-notification-settings-module":"default~routes-screen-screen-module~users-user-notification-settings-user-notification-settings-module","routes-screen-screen-module":"routes-screen-screen-module","default~routes-audit-log-audit-log-module~routes-devices-devices-module~routes-doctor-reviews-doctor~bfb56ed7":"default~routes-audit-log-audit-log-module~routes-devices-devices-module~routes-doctor-reviews-doctor~bfb56ed7","routes-audit-log-audit-log-module":"routes-audit-log-audit-log-module","routes-devices-devices-module":"routes-devices-devices-module","default~routes-patients-overview-overview-module~routes-patients-patients-module~routes-questionarie~03f63a07":"default~routes-patients-overview-overview-module~routes-patients-patients-module~routes-questionarie~03f63a07","default~routes-patients-overview-overview-module~routes-questionaries-questionaries-module~routes-qu~4efcb0dd":"default~routes-patients-overview-overview-module~routes-questionaries-questionaries-module~routes-qu~4efcb0dd","default~routes-patients-overview-overview-module~routes-questionaries-questionaries-module":"default~routes-patients-overview-overview-module~routes-questionaries-questionaries-module","routes-patients-overview-overview-module":"routes-patients-overview-overview-module","routes-questionaries-questionaries-module":"routes-questionaries-questionaries-module","routes-questions-questions-module":"routes-questions-questions-module","default~routes-medical-staff-medical-staff-module~routes-users-users-module":"default~routes-medical-staff-medical-staff-module~routes-users-users-module","routes-medical-staff-medical-staff-module":"routes-medical-staff-medical-staff-module","routes-doctor-reviews-doctor-reviews-module":"routes-doctor-reviews-doctor-reviews-module","routes-garmin-app-garmin-app-module":"routes-garmin-app-garmin-app-module","routes-medical-centers-medical-centers-module":"routes-medical-centers-medical-centers-module","routes-phone-application-version-phone-application-version-module":"routes-phone-application-version-phone-application-version-module","routes-sims-sims-module":"routes-sims-sims-module","routes-translations-translations-module":"routes-translations-translations-module","routes-google-maps-google-maps-module":"routes-google-maps-google-maps-module","firebase-auth":"firebase-auth","firebase-messaging":"firebase-messaging","canvg":"canvg","dompurify":"dompurify","daily-conclusion-daily-conclusion-module":"daily-conclusion-daily-conclusion-module"}[chunkId]||chunkId) + "-es2015." + {"default~components-appointments-app-module~routes-audit-log-audit-log-module~routes-devices-devices-~113f39d9":"19c3febe168b9c45dfaf","default~components-appointments-app-module~routes-patients-overview-overview-module~routes-patients-~5fb513a5":"88947c981376fb352a50","default~components-appointments-app-module~routes-patients-overview-overview-module~routes-screen-sc~039700e5":"07946e965bebebf66434","default~components-appointments-app-module~routes-screen-screen-module":"1e4d4c6490690c304100","components-appointments-app-module":"b3b26392d2c1546c8b4b","default~routes-audit-log-audit-log-module~routes-devices-devices-module~routes-patients-overview-ove~6580492d":"e7e823590c0c5f4f1f79","default~routes-medical-staff-medical-staff-module~routes-patients-overview-overview-module~routes-pa~5c79f3f6":"a7728bb7a37e8835a7fd","default~routes-audit-log-audit-log-module~routes-patients-overview-overview-module~routes-patients-p~a2272458":"8ff14163c2eabf2ff685","default~daily-conclusion-daily-conclusion-module~routes-report-report-module":"4d7211e71da7e01b4001","routes-report-report-module":"d99af335ee1052ba13f5","default~routes-audit-log-audit-log-module~routes-devices-devices-module~routes-patients-overview-ove~b66bdf83":"b7c08cc397687d1041e1","default~routes-devices-devices-module~routes-google-maps-google-maps-module~routes-patients-overview~a0bb2fc7":"0eda530a2d1f098df5c9","default~routes-patients-overview-overview-module~routes-patients-patients-module~routes-questionarie~b4eda962":"d8a1bfb03aabeabb0684","default~routes-patients-overview-overview-module~routes-screen-screen-module":"6dbf81bd4fc6c126a245","default~routes-google-maps-google-maps-module~routes-screen-screen-module":"c90cb3087cd661214fd7","default~routes-screen-screen-module~users-user-notification-settings-user-notification-settings-module":"6c4d1d28440f539b9358","routes-screen-screen-module":"64db05c0c69f395173fa","default~routes-audit-log-audit-log-module~routes-devices-devices-module~routes-doctor-reviews-doctor~bfb56ed7":"f7ee2a20c7d857a04ac4","routes-audit-log-audit-log-module":"07b471b80ea08ddee279","routes-devices-devices-module":"1992204d39a0efa7ae3f","default~routes-patients-overview-overview-module~routes-patients-patients-module~routes-questionarie~03f63a07":"8a9d32b4d7a6fd345c25","default~routes-patients-overview-overview-module~routes-questionaries-questionaries-module~routes-qu~4efcb0dd":"6f9832715cdc93dc6803","default~routes-patients-overview-overview-module~routes-questionaries-questionaries-module":"59cedf28ae2dd3f411a6","routes-patients-overview-overview-module":"37907539c212b32c8d9d","routes-questionaries-questionaries-module":"7ecfe633d08df0782503","routes-questions-questions-module":"62ebfae6bc0498919182","default~routes-medical-staff-medical-staff-module~routes-users-users-module":"f4307aa4b44230b9fb5f","routes-medical-staff-medical-staff-module":"aae9e64117289732c759","routes-doctor-reviews-doctor-reviews-module":"fa53f538ae975ea11525","routes-garmin-app-garmin-app-module":"56a0314388c4eaca623f","routes-medical-centers-medical-centers-module":"2a4aaa7ed1b475c8f3d9","routes-phone-application-version-phone-application-version-module":"89461db37777d6f179aa","routes-sims-sims-module":"e7ffb54391ccba29cc15","routes-translations-translations-module":"fc2281e719c4e858e04e","routes-google-maps-google-maps-module":"af09ebc92f9ff80789bd","firebase-auth":"73c2d001e36d80014673","firebase-messaging":"76493a4ae633c0068f56","canvg":"32f661be2c6ca40e4122","dompurify":"76e7fcff9696880a4a52","daily-conclusion-daily-conclusion-module":"fab3491f0f99965e3b91"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
